// extracted by mini-css-extract-plugin
export default {"todowrapper":"TodoWrapper_todowrapper__OhVru","head":"TodoWrapper_head__5tIzJ","heading":"TodoWrapper_heading__Qo8oY","taskWrapper":"TodoWrapper_taskWrapper__z6Pbv"};